import { Link } from "react-router-dom";
import { categories } from "@/mocks/home";

export default function CategoriesSection() {
  return (
    <section id="categories" className="bg-background-100 py-16 md:py-24">
      <div className="w-full px-4 md:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12">
          <div className="max-w-2xl">
            <p className="text-xs tracking-[0.25em] uppercase text-primary-600 mb-3">内容分类</p>
            <h2 className="font-heading font-bold text-2xl md:text-4xl text-foreground-950">
              这些类型的信息都可以提交
            </h2>
            <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-600">
              只要内容与公共利益或他人正当权益相关，并且你能讲清基本事实，就值得被记录。
            </p>
          </div>
          <Link
            to="/guide"
            className="inline-flex items-center gap-2 text-sm font-medium text-primary-700 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看受理标准
            <i className="ri-arrow-right-line" aria-hidden="true"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {categories.map((item) => (
            <article
              key={item.title}
              className="bg-background-50 border border-background-200 rounded-lg p-6 flex flex-col hover:border-primary-300 transition-colors"
            >
              <div className="flex items-start justify-between mb-4">
                <span className="w-11 h-11 flex items-center justify-center rounded-lg bg-primary-100 text-primary-700">
                  <i className={`${item.icon} text-xl`} aria-hidden="true"></i>
                </span>
                <span className="text-xs text-foreground-500 bg-background-100 px-2.5 py-1 rounded-full">
                  {item.count}
                </span>
              </div>
              <h3 className="font-heading font-semibold text-base text-foreground-950 mb-2">{item.title}</h3>
              <p className="text-sm leading-relaxed text-foreground-600">{item.desc}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}